<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <v-button
          icon="home"
          style-type="link"
          type="button"
          @click="$router.push({name: 'admin-dashboard'})"
        />
        <h3 class="m-0">
          {{ $tc('word.research', 2) }}
          <small class="text-muted">({{ totalObjects }})</small>
        </h3>
      </div>
      <div class="d-flex">
        <div class="mr-2">
          <a href="/admin/core/research/" class="btn btn-link">
            Open Django Admin
          </a>
        </div>
        <div class="mr-2">
          <form class="d-flex" method="post" @submit.prevent="filterObjects(searchQuery)">
            <div class="mr-3 pt-2 d-flex align-items-center">
              <div class="mr-2">
                <v-check-box
                  label="phrase.show_all"
                  v-model="showAll"
                />
              </div>

              <i
                class="fa fa-info-circle mb-2"
                data-toggle="tooltip"
                v-title="$t('sentence.show_all_tooltip')"
              ></i>
            </div>
            <div class="mr-2">
              <v-text-input
                id="research-list-search"
                v-model="searchQuery"
                placeholder="word.search"
              />
            </div>
            <v-button
              icon="rotate-left"
              style-type="link"
              type="button"
              :disabled="!searchQuery"
              @click="reset"
            />
            <div>
              <v-button
                icon="search"
                style-type="secondary"
                type="submit"
              />
            </div>
          </form>
        </div>
        <div>
          <v-button
            icon="plus"
            style-type="primary"
            :route-to="{name: 'admin-research-create'}"
            type="button"
          />
        </div>
      </div>
    </div>
    <table class="table table-hover">
      <thead>
      <th>{{ $tc('word.organisation', 1) }}</th>
      <th>{{ $t('word.title') }}</th>
      <th>{{ $t('word.research_proposal') }}</th>
      <th>{{ $t('word.start_date') }}</th>
      <th>{{ $t('word.sessions') }}</th>
      <th>{{ $t('word.status') }}</th>
      </thead>
      <tbody>
      <tr
        v-for="research in objectList"
        :key="research.id"
        class="hover-row clickable"
      >
        <td
          @click="goToDetail(research.uuid)"
        >
          {{ research.organisation.name }}
        </td>
        <td @click="goToDetail(research.uuid)">
          {{ research.title }}
        </td>
        <td @click="goToDetail(research.uuid)">
          <span v-if="research.proposal">
            {{ research.proposal.title }}
          </span>
        </td>
        <td
          @click="goToDetail(research.uuid)"
        >
          {{ getDateDifferenceInDays(research.start_date) }}
        </td>
        <td
          @click="goToDetail(research.uuid)"
          style="width: 30px"
          class="text-right"
        >
          <div
            class="badge badge-dark w-100"
          >
            {{ research.sessions_count }} / {{ research.group_size }}
          </div>
        </td>
        <td
          @click="goToDetail(research.uuid)"
          style="width: 30px"
        >
          <v-research-status-badge
            :status="research.status"
            :full-width="true"
          />
        </td>
      </tr>
      </tbody>
    </table>

    <div class="p-3 d-flex align-items-center flex-column">
      <v-button
        text="phrase.load_more"
        v-if="nextPageUrl"
        @click="getObjects(nextPageUrl, true)"
        :loader="{loading: loading}"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Button from '@/common/components/Button.vue';
import ResearchStatusBadge from '@/common/components/research/ResearchStatusBadge.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import CheckBox from '@/common/components/inputs/CheckBox.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import { getPrettyDateDifferenceInDays } from '@/common/utils/datetime';

export default {
  name: 'ResearchList',
  components: {
    'v-button': Button,
    'v-check-box': CheckBox,
    'v-research-status-badge': ResearchStatusBadge,
    'v-text-input': TextInput,
  },
  data() {
    return {
      apiPath: 'admin/researches/',
      researchToCopy: null,
      showAll: false,
    };
  },
  watch: {
    showAll() {
      this.loading = true;
      setTimeout(() => {
        this.getObjects();
      }, 200);
    },
  },
  methods: {
    getParams() {
      if (this.showAll) {
        return {};
      }
      return {
        start_date_lte: moment(new Date()).format('YYYY-MM-DD'),
      };
    },
    getDateDifferenceInDays(d) {
      if (d) {
        return getPrettyDateDifferenceInDays(new Date(), new Date(d));
      }
      return '-';
    },
    goToDetail(researchUUID) {
      this.$router.push({
        name: 'admin-research-detail',
        params: {
          uuid: researchUUID,
        },
      });
    },
  },
  mixins: [
    GenericListMixin,
  ],
};
</script>
